export default __webpack_public_path__ + "static/media/25a31967edeff2c2.e1b49804f5b4844b070cbc2177c9e23b.svg";